// ─── Helpers para comparação robusta de estados ─────────────────────────────
// A base de dados usa estados com acentos e maiúsculas (ex: "Concluída", "Em Curso")
// Esta função normaliza para minúsculas sem acentos para comparações seguras.

export function estadoNormalizado(estado: string | undefined | null): string {
  if (!estado) return '';
  return estado
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '_');
}